// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import Vuelidate from 'vuelidate'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import Navbar from './components/Navbar'
import router from './router'
import store from './store'
import 'datalist-polyfill'

Vue.config.productionTip = false

// Fase 0 del plan de monedero: el login ya generaba un JWT y se guardaba en
// localStorage ('ew-user-token'), pero ningún request lo volvía a mandar —
// el backend identificaba al usuario solo por el id plano que viaja en el
// body/query ('ew-user-id'), sin firma. Este interceptor lo agrega como
// header en cada petición saliente; se lee de localStorage en cada request
// (no una sola vez al arrancar) para que login/logout tomen efecto sin
// recargar la página.
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('ew-user-token')
  if (token) {
    config.headers['x-access-token'] = token
  }
  return config
})

// La sesión del navegador (localStorage 'ew-user-id') nunca caduca por sí
// sola, pero el JWT sí: 10 días desde el login (authJWT.sign). Antes de
// este interceptor, un token vencido no se notaba hasta que el usuario
// intentaba algo que SÍ lo verifica (pagar con monedero, crear/borrar un
// movimiento) — recibía un 401 silencioso y el botón solo se quedaba sin
// avanzar, sin ninguna pista de que hacía falta volver a iniciar sesión.
// Se excluye /login explícitamente: ese endpoint nunca responde 401 (usa
// 404 para credenciales inválidas), pero así queda a prueba de cambios.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const isUnauthorized = error.response && error.response.status === 401
    const isLoginRequest = error.config && error.config.url && error.config.url.indexOf('/login') !== -1
    if (isUnauthorized && !isLoginRequest) {
      localStorage.removeItem('ew-user-id')
      localStorage.removeItem('ew-user-token')
      if (router.currentRoute.path !== '/signin') {
        router.push({
          path: '/signin',
          query: { redirect: router.currentRoute.fullPath, expired: 'true' }
        })
      }
    }
    return Promise.reject(error)
  }
)

Vue.use(Vuelidate)
Vue.use(BootstrapVue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App, Navbar },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js